module.exports = __webpack_public_path__ + "img/map_pin_home.e453f0c3.svg";